export default "__VITE_ASSET__D_s$y_rQ__"